<template>
  <div class="select-universities">
    <base-button
      v-if="!loading_data"
      inverse
      class="text-nowrap py-0 pb-1 px-2 mx-0"
      @click="addUniversity"
    >
      <small>
        <span class="badge badge-pill badge-danger mr-2">{{ selected_amount }}</span>
        <fa-icon icon="university" />
        Agregar Universidad
      </small>
    </base-button>
    <loading :loading="loading_data" />

    <base-modal
      id="AddUniversity"
      title="Agregar institución de educación superior"
      :show="show"
      @closed="closeModal"
    >
      <div class="d-flex justify-content-between align-items-center select-universities__header">
        <div>
          <div>Universidades e instituciones que imparten:</div>
          <div class="select-universities__title">
            {{ career.career_name }}
          </div>
        </div>
        <div>
          <span class="badge d-inline-flex justify-content-end  badge-pill badge-danger">
            {{ selected_amount }}
          </span>
          <fa-icon
            icon="university"
            size="2x"
          />
        </div>
      </div>

      <UniversityCell
        v-for="(item, index) in items"
        :key="index"
        :index="index"
        :university="item"
        @select="onSelect"
      />
      <div class="w-100">
        <base-button
          style="float: right;"
          @click="closeModal"
        >
          Guardar
        </base-button>
      </div>
    </base-modal>
  </div>
</template>
<script>
import UniversityCell from './UniversityCell.vue';
import { institutionsService } from '../../_services';

export default {
    name: 'SelectUniversities',
    components: {
        UniversityCell,
    },
    props: {
        career: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            forceRecomputeCounter: 0,
            loading_data: false,
            show: false,
            items: [],
            selected: [],
        };
    },
    computed: {
        selected_amount() {
            /* eslint-disable-next-line no-unused-expressions */
            this.forceRecomputeCounter;
            return this.selected.reduce((accumulator, currentValue) => {
                if (currentValue) {
                    return accumulator + 1;
                }
                return accumulator;
            }, 0);
        },
    },
    mounted() {
        this.$nextTick(function () {
            this.getData();
        });
    },
    methods: {
        addUniversity() {
            this.show = true;
            this.$store.dispatch('clippyNotifications/addUniversity', 'OPEN_FAVORITES');
        },
        closeModal() {
            this.show = false;
            // Cancel notification with advise about select university
            this.$store.dispatch('clippyNotifications/selectUniversity');
        },
        getData() {
            this.loading_data = true;
            institutionsService.getImpartedCareers(
                this.career.career_uuid,
            ).then((response) => {
                this.items = response.data;
                this.items.forEach((e) => {
                    this.selected.push(e.checked);
                });
            }).finally(() => {
                this.loading_data = false;
            });
        },
        onSelect(item, index, impartedId) {
            this.selected[index] = item;
            // Trickster to trick the computed
            this.forceRecomputeCounter += 1;
            this.$emit('select', item, impartedId);
            if (item) {
                if (this.selected_amount > 6) {
                    this.$store.dispatch('clippyNotifications/addDirectMessage', 'MORE_THAN_X_SELECTED_CAREERS');
                }
                this.$store.dispatch('clippyNotifications/addDirectMessage', 'WATCH_UNIVERSITY_DETAILS');
            }
        },
    },
};
</script>
<style lang="scss">
.select-universities{
  &__header{
    position: sticky;
    top: -1px;
    background: white;
    z-index:9999;
  }

  &__title{
    font-size: 1.2rem;
    @media (min-width: 768px) {
      font-size: 1.75rem;
    }
  }
}
</style>
